import React from 'react';
import { MapTrifold, FunnelSimple } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import { ClusterType } from 'shared/types/cluster';

interface ClusterTypeToggleProps {
  value: ClusterType;
  onChange: (type: ClusterType) => void;
  disabled?: boolean;
}

export const ClusterTypeToggle: React.FC<ClusterTypeToggleProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-foreground">
        Cluster type
      </label>
      <div className="grid grid-cols-2 gap-3">
        {/* Manual Option */}
        <button
          type="button"
          onClick={() => onChange(ClusterType.MANUAL)}
          disabled={disabled}
          className={cn(
            'flex flex-col items-center gap-2 p-4 rounded-lg border-2 transition-all',
            'hover:bg-muted/50 focus:outline-none focus:ring-2 focus:ring-brick-primary focus:ring-offset-2',
            value === ClusterType.MANUAL
              ? 'border-brick-primary bg-brick-secondary-fine/30'
              : 'border-border bg-card',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
        >
          <div
            className={cn(
              'p-3 rounded-xl transition-colors',
              value === ClusterType.MANUAL
                ? 'bg-brick-primary/10'
                : 'bg-muted'
            )}
          >
            <MapTrifold
              className={cn(
                'size-6',
                value === ClusterType.MANUAL
                  ? 'text-brick-primary'
                  : 'text-muted-foreground'
              )}
              weight="duotone"
            />
          </div>
          <div className="text-center">
            <p
              className={cn(
                'font-medium',
                value === ClusterType.MANUAL
                  ? 'text-brick-primary'
                  : 'text-foreground'
              )}
            >
              Handmatig
            </p>
            <p className="text-xs text-muted-foreground mt-0.5">
              Selecteer gebouwen handmatig
            </p>
          </div>
          {/* Radio indicator */}
          <div
            className={cn(
              'w-4 h-4 rounded-full border-2 flex items-center justify-center',
              value === ClusterType.MANUAL
                ? 'border-brick-primary'
                : 'border-muted-foreground/30'
            )}
          >
            {value === ClusterType.MANUAL && (
              <div className="w-2 h-2 rounded-full bg-brick-primary" />
            )}
          </div>
        </button>

        {/* Filter Option */}
        <button
          type="button"
          onClick={() => onChange(ClusterType.FILTER)}
          disabled={disabled}
          className={cn(
            'flex flex-col items-center gap-2 p-4 rounded-lg border-2 transition-all',
            'hover:bg-muted/50 focus:outline-none focus:ring-2 focus:ring-moss-primary focus:ring-offset-2',
            value === ClusterType.FILTER
              ? 'border-moss-primary bg-moss-secondary-light/30'
              : 'border-border bg-card',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
        >
          <div
            className={cn(
              'p-3 rounded-xl transition-colors',
              value === ClusterType.FILTER
                ? 'bg-moss-primary/10'
                : 'bg-muted'
            )}
          >
            <FunnelSimple
              className={cn(
                'size-6',
                value === ClusterType.FILTER
                  ? 'text-moss-primary'
                  : 'text-muted-foreground'
              )}
              weight="duotone"
            />
          </div>
          <div className="text-center">
            <p
              className={cn(
                'font-medium',
                value === ClusterType.FILTER
                  ? 'text-moss-primary'
                  : 'text-foreground'
              )}
            >
              Filter-gebaseerd
            </p>
            <p className="text-xs text-muted-foreground mt-0.5">
              Gebouwen automatisch op basis van filters
            </p>
          </div>
          {/* Radio indicator */}
          <div
            className={cn(
              'w-4 h-4 rounded-full border-2 flex items-center justify-center',
              value === ClusterType.FILTER
                ? 'border-moss-primary'
                : 'border-muted-foreground/30'
            )}
          >
            {value === ClusterType.FILTER && (
              <div className="w-2 h-2 rounded-full bg-moss-primary" />
            )}
          </div>
        </button>
      </div>
    </div>
  );
};

export default ClusterTypeToggle;
